import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Image from "next/image";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { RatingsData } from "../types";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useAuth } from "@/components/auth/Auth";
import { useIdentity } from "@/hooks/useIdentity";
interface VoteBreakdownTooltipProps {
  readonly drop: ApiDrop;
  readonly ratingsData: RatingsData;
}
export default function VoteBreakdownTooltip(t0) {
  const $ = _c(14);
  const {
    drop,
    ratingsData
  } = t0;
  const {
    hasRaters,
    userRating
  } = ratingsData;
  const votingPower = drop.context_profile_context?.max_rating ?? 0;
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  const {
    address
  } = useSeizeConnectContext();
  const {
    activeProfileProxy
  } = useAuth();
  const t1 = address ?? null;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      handleOrWallet: t1,
      initialProfile: null
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    profile
  } = useIdentity(t2);
  let t3;
  bb0: {
    if (activeProfileProxy) {
      t3 = activeProfileProxy.created_by.pfp;
      break bb0;
    }
    t3 = profile?.pfp ?? null;
  }
  const pfp = t3;
  let t4;
  if ($[2] !== drop.top_raters || $[3] !== hasRaters) {
    t4 = hasRaters && <div className="tw-space-y-2"><span className="tw-text-xs tw-font-medium tw-text-iron-400">Top Voters</span><div className="tw-space-y-1.5">{drop.top_raters.map(_temp)}</div></div>;
    $[2] = drop.top_raters;
    $[3] = hasRaters;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== drop.context_profile_context || $[6] !== pfp || $[7] !== userRating || $[8] !== votingLabel || $[9] !== votingPower) {
    t5 = drop.context_profile_context && <div className="tw-space-y-2"><div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2">{pfp ? <Image src={pfp} alt="Profile picture" width={16} height={16} className="tw-h-4 tw-w-4 tw-rounded-md tw-ring-1 tw-ring-white/10" /> : <div className="tw-h-4 tw-w-4 tw-rounded-md tw-ring-1 tw-ring-white/10 tw-bg-iron-800" />}<span className="tw-text-xs tw-font-medium tw-text-iron-400">Your Voting Power</span></div></div><div className="tw-flex tw-items-center tw-justify-between tw-pl-6"><span className="tw-text-xs tw-text-iron-300">Voting Range</span><div className="tw-flex tw-items-center"><div className="tw-flex tw-flex-col tw-items-center tw-mr-1 tw-leading-[0.15rem] -tw-space-y-2.5"><span className="tw-text-xs tw-font-medium tw-text-emerald-400">+</span><span className="tw-text-xs tw-font-medium tw-text-rose-400">−</span></div><span className="tw-text-xs tw-font-medium tw-text-iron-300">{formatNumberWithCommas(votingPower)} {votingLabel}</span></div></div><div className="tw-flex tw-items-center tw-justify-between tw-pl-6"><span className="tw-text-xs tw-text-iron-300">Voted</span><span className="tw-text-xs tw-font-medium tw-text-iron-300">{formatNumberWithCommas(Math.abs(userRating))} {votingLabel}</span></div></div>;
    $[5] = drop.context_profile_context;
    $[6] = pfp;
    $[7] = userRating;
    $[8] = votingLabel;
    $[9] = votingPower;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-p-3 tw-space-y-3 tw-min-w-[200px]">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(rater) {
  return <div key={rater.profile.id} className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2">{rater.profile.pfp && <Image src={getScaledImageUri(rater.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${rater.profile.handle}'s profile picture`} width={16} height={16} className="tw-h-4 tw-w-4 tw-rounded-md tw-ring-1 tw-ring-white/10" />}<span className="tw-text-xs tw-font-medium tw-text-iron-300">{rater.profile.handle}</span></div><span className={`tw-text-xs tw-font-medium ${rater.rating >= 0 ? "tw-text-emerald-400" : "tw-text-rose-400"}`}>{rater.rating > 0 && "+"}{formatNumberWithCommas(rater.rating)}</span></div>;
}